module.exports = __webpack_public_path__ + "img/prizes-icon.5c24bc9.svg";